var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"scrolltop",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.scrollToNextSection();}}},[_c('img',{attrs:{"src":"images/commons/circle_down.svg","alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }